'use client'

import React, {useEffect, useRef} from 'react'
import {useQueryClient} from '@tanstack/react-query'
import {useAuth} from '@/lib/clerk-nextjs'

interface AuthCacheResetBoundaryProps {
    children: React.ReactNode
}

export function AuthCacheResetBoundary({children}: AuthCacheResetBoundaryProps) {
    const queryClient = useQueryClient()
    const {isLoaded, userId} = useAuth()
    const previousUserIdRef = useRef<string | null | undefined>(undefined)

    useEffect(() => {
        if (!isLoaded) return

        const currentUserId = userId ?? null
        const previousUserId = previousUserIdRef.current
        previousUserIdRef.current = currentUserId

        if (previousUserId === undefined || previousUserId === currentUserId) {
            return
        }

        queryClient.clear()
    }, [isLoaded, queryClient, userId])

    return <>{children}</>
}
